/**
 * Calculate widths of columns from stops.
 * Sorts stops in ascending order and then `width = stop - previousStop`.
 *
 * e.g. possibleWidthsFromColumnStops(new Set([699, 233])) => [233, 466]
 */
export const possibleWidthsFromColumnStops = (columnStops: Set<number>) =>
  Array.from(columnStops)
    .sort((a, b) => a - b)
    .map((stop, index, columnArray) => (index === 0 ? stop : stop - columnArray[index - 1]))
